import { Image } from '@com-delta-idp/mnx-ui-kit';
import { GenericLabel } from '@com-delta-idp/mnx-utils';

export type VerticalPositionType = 'right' | 'left';

export interface BannerImage extends Image {
  position: VerticalPositionType;
}

export interface CardCarouselBanner {
  labels: GenericLabel;
  image: BannerImage;
}
